<template>
    <div>
        <div class="row pt-2" :class="{'bg-light-light': key % 2 == 0}" v-for="(item, key) in items" :key="key">
            <label class="label label-primary">{{ key+1 }}</label>
            <br/>
            <div class="col-md-12">
                <div class="row">
                    <div class="form-group col-md-8">
                        <label>Nama Bagian *</label>
                        <input :name="`name[${key}]`" class="form-control" placeholder="Eg: Indikator Kinerja Keuangan" v-model="item.name" />
                    </div>
                    <div class="form-group col-md-2">
                        <label>Urutan Form</label>
                        <input :name="`order[${key}]`" class="form-control" placeholder="Eg: 1-10" v-model="item.order" />
                    </div>
                </div>
            </div>
            <div class="col-md-12 pb-2" v-for="(detail, detailKey) in item.template_report_rsb_details" :key="detailKey">
                <div class="card">
                    <div class="card-body p-4">
                        <label class="label label-primary">{{key+1}}.{{ detailKey+1 }}</label>
                        <br/>
                        <div class="row">
                            <div class="form-group col-md-5">
                                <label>Indikator Kinerja *</label>
                                <select
                                    :id="`template_form_data_detail_id${key}_${detailKey}`"
                                    :name="`template_form_data_detail_id[${key}][${detailKey}]`"
                                    class="form-control indicator"
                                    style="width:100%"
                                    v-model="detail.template_form_data_detail_id"
                                    v-select="detail.template_form_data_detail_id"
                                    @change="onSelectIndicator(key, detailKey, detail.template_form_data_detail_id)">
                                </select>
                                <span class="form-text text-muted">Data sesuai dengan input pelaporan data</span>
                            </div>
                            <div class="form-group col-md-4">
                                <label>Rumus Capaian</label>
                                <input :name="`indicator_formula[${key}][${detailKey}]`" class="form-control" placeholder="Eg: [A]/[B]*100" v-model="detail.indicator_formula" />
                                <span v-if="detail.report_indicator_labels.length <= 0" class="form-text text-muted">Keterangan tampil pada saat Anda memilih Indikator Kinerja</span>
                                <template v-for="(data, i) in detail.report_indicator_labels">
                                    <span class="form-text text-muted" :key="i">[{{ alphabet(i) }}]: {{ data.name }}</span>
                                </template>
                            </div>
                            <div class="form-group col-md-2">
                                <label>Bobot IKU *</label>
                                <div class="input-group">
                                    <input type="number" :name="`iku_score[${key}][${detailKey}]`" class="form-control" placeholder="Eg: 15" v-model="detail.iku_score" />
                                    <div class="input-group-append"><span class="input-group-text">%</span></div>
                                </div>
                                <span class="form-text text-muted">Hasil = Capaian / Target * Bobot IKU</span>
                            </div>
                            <div class="col-md-1 d-flex justify-content-end mt-8">
                                <button @click="removePart(key, detailKey)" type="button" class="btn btn-light-danger btn-sm btn-icon"><i class="la la-times"></i></button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-md-2">
                                <label>Target Indikator *</label>
                                <input type="number" :name="`target_indicator[${key}][${detailKey}]`" class="form-control" placeholder="Eg: 75" v-model="detail.target_indicator" />
                            </div>
                            <div class="form-group col-md-2">
                                <label>Target Satuan *</label>
                                <input :name="`target_unit[${key}][${detailKey}]`" class="form-control" placeholder="Eg: %, Hari" v-model="detail.target_unit" />
                            </div>
                            <div class="form-group col-md-2">
                                <label>PIC</label>
                                <input type="text" :name="`pic_name[${key}][${detailKey}]`" class="form-control" v-model="detail.pic_name" />
                            </div>
                            <div class="form-group col-md-2">
                                <label>Sumber</label>
                                <input type="text" :name="`source_name[${key}][${detailKey}]`" class="form-control" v-model="detail.source_name" />
                            </div>
                            <div class="form-group col-md-2">
                                <label>Realisasi</label>
                                <input type="text" :name="`realization_name[${key}][${detailKey}]`" class="form-control" placeholder="Eg: Semester" v-model="detail.realization_name" />
                            </div>
                            <div class="form-group col-md-1">
                                <label>Haper</label>
                                <input type="number" :name="`haper[${key}][${detailKey}]`" class="form-control" placeholder="Eg: 10.10" v-model="detail.haper" />
                            </div>
                            <div class="form-group col-md-1">
                                <label>Urutan Form</label>
                                <input :name="`order[${key}][${detailKey}]`" class="form-control" placeholder="Eg: 1-10" v-model="detail.order" />
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12 p-4 d-flex justify-content-center">
                <button type="button" @click="addNewPart(key)" class="btn btn-info"><i class="la la-plus"></i>&nbsp;&nbsp;Tambah Sub Bagian</button>
            </div>
        </div>
        <div class="pt-4">
            <button type="button" @click="addNew()" class="btn btn-success"><i class="la la-plus"></i>&nbsp;&nbsp;Tambah Bagian</button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'TemplateReportRsbForm',
        props: {
            save: Number,
            year: [String, Number],
            initialItems: Array
        },
        computed: {
        },
        data() {
            return {
                items: [],
            }
        },
        watch: {
            save(val) {
                this.$emit('items', this.items)
            }
        },
        mounted() {
            if(this.initialItems) {
                this.items = this.initialItems
                setTimeout(() => {
                    this.loadIndicators()
                    this.items.map((item, key) => {
                        item.template_report_rsb_details.map((detail, detailKey) => {
                            $(`#template_form_data_detail_id${key}_${detailKey}`)
                                .empty()
                                .append(`<option value="${detail.template_form_data_detail_id}">${detail.template_form_data_detail.unit_with_indicator_name}</option>`)
                                .val(detail.template_form_data_detail_id)
                                .trigger('change')
                        })
                    })
                }, 300)
            }
        },
        methods: {
            removePart(key, detailKey) {
                this.items[key].template_report_rsb_details.splice(detailKey, 1)
            },
            removePartDetail(key, detailKey, formulaKey) {
                this.items[key].template_report_rsb_details[detailKey].details.splice(formulaKey, 1)
            },
            addNewPart(key) {
                this.items[key].template_report_rsb_details.push({
                    key: Math.random(4),
                    template_form_data_detail_id: null,
                    indicator_id: null,
                    report_indicator_labels: [],
                    indicator_formula: null,
                    target_indicator: null,
                    target_unit: null,
                    iku_score: null,
                    pic_name: null,
                    source_name: null,
                    realization_name: null,
                    haper: null,
                    order: null,
                })
                setTimeout(() => {
                    this.loadIndicators()
                }, 300)
            },
            addNew() {
                this.items.push({
                    key: Math.random(4),
                    name: null,
                    order: null,
                    template_report_rsb_details: [
                        {
                            key: Math.random(4),
                            template_form_data_detail_id: null,
                            indicator_id: null,
                            report_indicator_labels: [],
                            indicator_formula: null,
                            target_indicator: null,
                            target_unit: null,
                            iku_score: null,
                            pic_name: null,
                            source_name: null,
                            realization_name: null,
                            haper: null,
                            order: null,
                        }
                    ]
                })
                setTimeout(() => {
                    this.loadIndicators()
                }, 300)
            },
            loadIndicators() {
                const app = this
                $('.indicator').select2({
                    placeholder: '-- Pilih salah satu --',
                    width: 'resolve',
                    ajax: {
                        url: '/ajax/dropdown-indicators-from-template',
                        dataType: "json",
                        type: "GET",
                        data: function (params) {
                            return {
                                search: params.term,
                                year: app.year
                            }
                        },
                        processResults: function (data, page) {
                            return {
                                results: data
                            };
                        }
                    }
                })
            },
            onSelectIndicator(key, detailKey, val) {
                this.items[key].template_report_rsb_details[detailKey].template_form_data_detail_id = val
                const params = {
                    year:this.year,
                    template_form_data_detail_id: val
                }
                axios.get('/ajax/get-template-indicator-labels', {
                    params
                }).then(({ data }) => {
                    const respData = data.data
                    this.items[key]
                        .template_report_rsb_details[detailKey]
                        .indicator_id = respData.indicator_id
                    this.items[key]
                        .template_report_rsb_details[detailKey]
                        .report_indicator_labels = respData.report_indicator_labels
                    this.items[key]
                        .template_report_rsb_details[detailKey]
                        .indicator_formula = respData.result_formula
                })
            }
        }
    }
</script>
